import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const CompanySettingSchema = withDefaults({
  type: 'company-setting',
  objectExtensions: ['company-setting'],
  fields: [
    {
      kind: 'attribute',
      name: 'allowFamilyPlan',
    },
    {
      kind: 'attribute',
      name: 'eligibilityDefault',
    },
    {
      kind: 'attribute',
      name: 'emailOverrides',
    },
    {
      kind: 'attribute',
      name: 'employeeCustomAttributes',
    },
    {
      kind: 'attribute',
      name: 'employeePortal529Tab',
    },
    {
      kind: 'attribute',
      name: 'employeePortalTab',
    },
    {
      kind: 'attribute',
      name: 'enums',
    },
    {
      kind: 'attribute',
      name: 'extraAuthVerification',
    },
    {
      kind: 'attribute',
      name: 'gradvisorDomain',
    },
    {
      kind: 'attribute',
      name: 'idProvider',
    },
    {
      kind: 'attribute',
      name: 'imputedIncome',
    },
    {
      kind: 'attribute',
      name: 'invoicing',
    },
    {
      kind: 'attribute',
      name: 'isDefault',
    },
    {
      kind: 'attribute',
      name: 'isGlobal',
    },
    {
      kind: 'attribute',
      name: 'landingPage',
    },
    {
      kind: 'attribute',
      name: 'loanEligibility',
    },
    {
      kind: 'attribute',
      name: 'modules',
    },
    {
      kind: 'attribute',
      name: 'newDesign',
    },
    {
      kind: 'attribute',
      name: 'partnerType',
    },
    {
      kind: 'attribute',
      name: 'payrollCustomText',
    },
    {
      kind: 'attribute',
      name: 'provider',
    },
    {
      kind: 'attribute',
      name: 'quickSight',
    },
    {
      kind: 'attribute',
      name: 'register',
    },
    {
      kind: 'attribute',
      name: 'registerPageCopy',
    },
    {
      kind: 'attribute',
      name: 'returnToPartnerUrl',
    },
    {
      kind: 'attribute',
      name: 'security',
    },
    {
      kind: 'attribute',
      name: 'sftpUserName',
    },
    {
      kind: 'attribute',
      name: 'ssoAuthUrl',
    },
    {
      kind: 'attribute',
      name: 'idpSloUrl',
    },
    {
      kind: 'attribute',
      name: 'subDomain',
    },
    {
      kind: 'attribute',
      name: 'tuitionAssistance',
    },
    {
      kind: 'attribute',
      name: 'tuitionmanagerAccount',
    },
    {
      kind: 'attribute',
      name: 'fiscalYear',
    },
    {
      kind: 'attribute',
      name: 'tasPaymentSettings',
    },
    {
      kind: 'attribute',
      name: 'paymentSettings',
    },
    {
      kind: 'attribute',
      name: 'lpn',
    },
    {
      kind: 'attribute',
      name: 'processConfig',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: true,
        inverse: 'companySetting',
      },
    },
    {
      kind: 'hasMany',
      name: 'companyLpnSetting',
      type: 'company-lpn-setting',
      options: {
        async: true,
        inverse: 'companySetting',
      },
    },
  ],
});

export default CompanySettingSchema;
